import { Avatar } from 'antd';
import React, { FC } from 'react';
import './JCMSIcon.scss';
import { JCMSImage } from '../JCMSImage';
import { CMSImage } from '../models';

export const JCMSIcon: FC<{ image: CMSImage[]; imgStyle?: React.CSSProperties }> = ({ image, imgStyle = {} }) => {
    return (
        <Avatar
            className="jcms-icon"
            icon={
                <div style={{ width: '65%', height: '65%', ...imgStyle}}>
                    <JCMSImage image={image}/>
                </div>
            } 
        />
    );
};